// extracted by mini-css-extract-plugin
export default {"container":"ErrorTips_container__kas33","error":"ErrorTips_error__SHVNT","warn":"ErrorTips_warn__E8Dga","sorryText":"ErrorTips_sorryText__Xep0D","text":"ErrorTips_text__lrTM8"};